import {
  __decorateClass
} from "./chunk.WHWUXFA2.js";

// src/components/jb-ref-table/jb-ref-table.ts
import "@bjb/bjb-web-components/dist/components/icons/jb-download-icon/jb-download-icon";
import "@bjb/bjb-web-components/dist/components/jb-button-primary/jb-button-primary";
import "@bjb/bjb-web-components/dist/components/jb-section-headline/jb-section-headline";
import { Spaceable } from "@bjb/bjb-web-components/dist/mixins";
import { html, LitElement, unsafeCSS } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { html as staticHtml, unsafeStatic } from "lit/static-html.js";

// src/components/jb-ref-table/jb-ref-table.scss?inline
import { css } from "lit-element/lit-element.js";
var jb_ref_table_default = css`/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.mobile-table .mobile-item .strong, .mobile-table .mobile-item > :nth-child(odd), .desktop-table td.strong, .desktop-table th {
  font-family: var(--theme-font-bold-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-bold-weight, 700);
}

.mobile-table .mobile-item > :nth-child(even):not(.strong), .desktop-table td {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

.mobile-table .mobile-item > :nth-child(even):not(.strong), .desktop-table td {
  font-size: var(--theme-typo-p-small-desktop-fontsize, 1rem);
  font-weight: var(--theme-typo-p-small-fontweight, var(--theme-font-light-weight, 300));
  line-height: var(--theme-typo-p-small-desktop-lineheight, 1.625rem);
}

.mobile-table .mobile-item .strong, .mobile-table .mobile-item > :nth-child(odd), .desktop-table td.strong, .desktop-table th {
  font-size: var(--theme-typo-p-small-highlight-desktop-fontsize, 1rem);
  font-weight: var(--theme-typo-p-small-highlight-fontweight, var(--theme-font-bold-weight, 700));
  line-height: var(--theme-typo-p-small-highlight-desktop-lineheight, 1.625rem);
}

.sr-only {
  block-size: 1px;
  border: 0;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
}

:host {
  display: grid;
  grid-template-columns: subgrid;
}
@media (min-width: 1281px) {
  :host {
    grid-column: 1/span 12 !important;
  }
}

jb-section-headline {
  grid-column: 1/span 12;
}

jb-section-headline + .desktop-table,
jb-section-headline ~ .mobile-table {
  margin-top: var(--theme-spacing-m);
}

.desktop-table {
  display: none;
  max-width: 100%;
  border-collapse: collapse;
  grid-column: 2/span 10;
}
@media (min-width: 1281px) {
  .desktop-table {
    display: table;
    width: 100%;
  }
}
.desktop-table.cols-12 {
  grid-column: 1/span 12;
}
.desktop-table tr:has(th) {
  border-bottom: 1px solid #141e55 !important;
}
.desktop-table tr:not(tbody :last-of-type) {
  border-bottom: 1px solid rgba(20, 30, 85, var(--theme-opacity-20, 0.2));
}
.desktop-table tr > :nth-child(2) {
  text-wrap: unset;
}
.desktop-table tr > :nth-child(n+3) {
  text-align: right;
}
.desktop-table th {
  color: #141e55;
  text-align: left;
}
.desktop-table th,
.desktop-table td {
  padding: var(--theme-spacing-3xs);
  text-wrap: nowrap;
}
.desktop-table td {
  color: rgba(20, 30, 85, var(--theme-opacity-80, 0.8));
}
.desktop-table td.strong {
  color: #141e55;
}
.desktop-table th > a:only-child,
.desktop-table td > a:only-child {
  display: flex;
  justify-content: center;
  align-items: center;
}
.desktop-table th > span + a,
.desktop-table td > span + a {
  margin-left: var(--theme-spacing-base);
}
.desktop-table th > span + a jb-ref-icon,
.desktop-table td > span + a jb-ref-icon {
  margin-bottom: -3px;
}

.mobile-table {
  display: flex;
  flex-direction: column;
  row-gap: var(--theme-spacing-sm);
  grid-column: 1/span 12;
}
@media (min-width: 1281px) {
  .mobile-table {
    display: none;
  }
}
.mobile-table .mobile-item {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.mobile-table .mobile-item > :nth-child(odd) {
  border-bottom: 1px solid rgba(20, 30, 85, var(--theme-opacity-20, 0.2));
  padding: var(--theme-spacing-3xs) 0;
}
.mobile-table .mobile-item > :nth-child(even) {
  text-align: right;
  padding: var(--theme-spacing-3xs);
}
.mobile-table .mobile-item > :nth-child(even):not(.strong) {
  border-bottom: 1px solid rgba(20, 30, 85, var(--theme-opacity-20, 0.2));
}
.mobile-table .mobile-item .strong {
  border-bottom: 1px solid #141e55;
}
.mobile-table .mobile-item > div > span + a {
  margin-left: var(--theme-spacing-base);
}
.mobile-table .mobile-item > div > span + a jb-ref-icon {
  display: none;
}
.mobile-table .mobile-item > :nth-child(even) a:only-child {
  height: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
}
.mobile-table .mobile-item > :nth-last-child(-n+2) {
  border-bottom: none !important;
}
.mobile-table jb-button-primary {
  width: 100%;
}
@media (min-width: 960px) {
  .mobile-table jb-button-primary {
    width: fit-content;
    align-self: end;
  }
}`;

// src/components/jb-ref-table/jb-ref-table.ts
var JbRefTable = class extends Spaceable(LitElement) {
  constructor() {
    super(...arguments);
    this._showAllRows = false;
  }
  _getContentSpacingProperties() {
    return { grid: true };
  }
  _headerRow() {
    return this.rows.find((row) => row.header).cells;
  }
  _rowsWithoutHeader() {
    if (this._showAllRows) return this.rows.filter((row) => !row.header);
    return this.rows.filter((row) => !row.header);
  }
  _renderCell(cell, wrapper = "div") {
    const renderContent = cell.content ? html`<span>${cell.content}</span>` : "";
    let iconLink = html``;
    if (cell.icon) {
      let icon = html``;
      if (cell.icon.name === "DOWNLOAD") {
        icon = html`<jb-download-icon title=${ifDefined(cell.icon.title)}></jb-download-icon>`;
      } else {
        icon = html`<jb-ref-icon name="${cell.icon.name}"></jb-ref-icon>`;
      }
      iconLink = html`<a
        href=${ifDefined(cell.icon.link?.href)}
        target=${ifDefined(cell.icon.link?.target)}
        ?download=${cell.icon.link?.download}
        >${icon}</a
      >`;
    }
    return staticHtml`<${unsafeStatic(wrapper)}
      class=${classMap({ strong: cell.strong })}
      title=${ifDefined(cell.tooltip || cell.icon?.title)}>
      ${renderContent}${iconLink}
    </${unsafeStatic(wrapper)}>`;
  }
  _renderCollapseButton() {
    return html`
      <jb-button-primary
        @click=${() => {
      this._showAllRows = !this._showAllRows;
    }}
        class="collapse-button"
      >
        ${this._showAllRows ? this.showLessLabel : this.showMoreLabel}
      </jb-button-primary>
    `;
  }
  _renderDesktopTable() {
    return html`
      <table class="desktop-table ${this.colsLg === 12 ? "cols-12" : "cols-10"}">
        <thead>
          ${this.rows?.filter((row) => row.header).map(
      (row) => html`<tr>
                  ${row.cells.map((cell) => this._renderCell(cell, "th"))}
                </tr>`
    )}
        </thead>

        <tbody>
          ${this.rows?.filter((row) => !row.header).map(
      (row) => html`<tr>
                  ${row.cells.map((cell) => this._renderCell(cell, "td"))}
                </tr>`
    )}
        </tbody>
      </table>
    `;
  }
  _renderMobileTable() {
    const renderGridRow = (cell, index) => html`
      ${this._renderCell(this._headerRow()[index])} ${this._renderCell(cell)}
    `;
    return html`<div class="mobile-table">
      ${this._rowsWithoutHeader().slice(0, this._showAllRows ? void 0 : 2).map((obj) => html`<div class="mobile-item">${obj.cells.map(renderGridRow)}</div>`)}
      ${this._rowsWithoutHeader().length > 2 ? this._renderCollapseButton() : ""}
    </div>`;
  }
  render() {
    return html`
      ${this.headline ? html`<jb-section-headline .headline=${this.headline}></jb-section-headline>` : ""}
      ${this._renderDesktopTable()} ${this._renderMobileTable()}
    `;
  }
};
JbRefTable.styles = unsafeCSS(jb_ref_table_default);
__decorateClass([
  property({ type: Number })
], JbRefTable.prototype, "colsLg", 2);
__decorateClass([
  property({ type: String })
], JbRefTable.prototype, "headline", 2);
__decorateClass([
  property({ type: Array })
], JbRefTable.prototype, "rows", 2);
__decorateClass([
  property()
], JbRefTable.prototype, "showLessLabel", 2);
__decorateClass([
  property()
], JbRefTable.prototype, "showMoreLabel", 2);
__decorateClass([
  state()
], JbRefTable.prototype, "_showAllRows", 2);
JbRefTable = __decorateClass([
  customElement("jb-ref-table")
], JbRefTable);

export {
  JbRefTable
};
